<template>
  <div>
    <a-input
      class="input"
      :read-only='true'
      placeholder="请选择"
      v-model="inputText"
      @click='selectedModal'
    >
      <a-icon
        v-if='inputText'
        class='close-icon'
        slot="suffix"
        type="close-circle"
        theme="filled"
        @click='clearEvent'
      />
    </a-input>
    <a-modal
      :title='modalTitle'
      :visible='modalVisible'
      @cancel='modalVisible = false'
      :footer='null'
    >
      <a-row>
        <a-col :span='16'>
          <a-input v-model='enterpriseName' :maxLength="20" placeholder='请输入企业名称'/>
        </a-col>
        <a-col :span='1'/>
        <a-col :span='4'>
          <a-button type='primary' @click='getEnterpriseList'>搜索</a-button>
        </a-col>
      </a-row>
      <div style="min-height: 120px;max-height: 600px;overflow: auto;">
        <a-table
          style='margin-top: 24px;'
          :columns="getColumns()"
          :data-source="enterpriseList"
          rowKey="enterpriseId"
          :pagination="false"
        >
          <div slot="action" slot-scope="text, record, index">
            <span v-if='inputValue == record.enterpriseId' class='chooseBtn chooseBtnNow'
                  @click="selectEnterprise(record)">当前选中</span>
            <span v-else class='chooseBtn' @click="selectEnterprise(record)">选择</span>
          </div>
        </a-table>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'SelectEnterpriseModal',
  props: {
    inputValue: {
      type: String | Number
    },
    inputText: {
      type: String,
      default: ''
    },
    modalTitle: {
      type: String,
      default: '选择企业'
    }
  },
  data() {
    return {
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      modalVisible: false,
      enterpriseName: '',
      enterpriseList: [] // 企业
    }
  },
  methods: {
    selectedModal() {
      this.enterpriseName = ''
      this.getEnterpriseList()
      this.modalVisible = true
    },
    getEnterpriseList() { // 获取企业数据
      this.enterpriseList = []
      this.getHttpServices().getServerApiService().post('welfare/getEnterpriseList', {
        limitDto: {
          pageNum: 1,
          pageSize: 10000
        },
        merchantId: this.merchantId,
        platformId: this.platformId,
        enterpriseName: this.enterpriseName
        // status: 1,
      }).then(res => {
        this.enterpriseList = res.data
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getColumns() {
      return [
        {
          title: '企业名称',
          dataIndex: 'enterpriseName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '120px',
          fixed: 'right'
        }
      ]
    },
    // 选择企业
    selectEnterprise(record) {
      this.$emit('selectEnterpriseEvent', {
        value: record.enterpriseId,
        text: record.enterpriseName
      })
      this.modalVisible = false
    },
    clearEvent() {
      this.$emit('selectEnterpriseEvent', {
        value: '',
        text: ''
      })
    }
  }
}
</script>

<style lang="less" scoped>
.chooseBtn {
  width: 80px;
  line-height: 32px;
  background-color: #daf0fb;
  color: #0999E0;
  display: block;
  text-align: center;
  border-radius: 2px;
  cursor: pointer;
}

.chooseBtn:hover {
  background-color: #aadcf5;
}

.chooseBtn.chooseBtnNow {
  background-color: #0999E0;
  color: #FFFFFF;
}

.input {
  width: 100%;
  cursor: pointer;

  .close-icon {
    font-size: 12px;
    color: #bfbfbf;
    display: none;
    cursor: pointer;
  }

  &:hover {
    .close-icon {
      display: flex;
    }
  }

  ::v-deep .ant-input {
    cursor: pointer;
  }
}
</style>
